import { render, staticRenderFns } from "./SalesOrdersDataTable.vue?vue&type=template&id=7c6d478a"
import script from "./SalesOrdersDataTable.vue?vue&type=script&lang=js"
export * from "./SalesOrdersDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports